import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { createHttpLink } from 'apollo-link-http';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from 'src/hooks/use-auth';
import { GLOBAL_ERROR_CODE } from '~graphql-types';

const httpLink = createHttpLink({ uri: process.env.REACT_APP_GQL_ENDPOINT });

const authLink = setContext((_, { headers }) => {
  const token = window.localStorage.getItem('token');
  return {
    headers: {
      ...headers,
      [process.env.REACT_APP_GQL_REQUEST_MARK]: token ? `Bearer ${token}` : undefined,
    },
  };
});

export const useApolloLink = () => {
  const [, { clearToken }] = useAuth();
  const history = useHistory();
  const location = useLocation();

  const responseErrorHandlerLink = useMemo(
    () =>
      onError(({ graphQLErrors }) => {
        const errorMessage = graphQLErrors?.[0].message?.toUpperCase();
        const code = Object.values(GLOBAL_ERROR_CODE).find((item) => item.includes(errorMessage));

        if (code) {
          if (
            code === GLOBAL_ERROR_CODE.UNAUTHORIZED ||
            (code === GLOBAL_ERROR_CODE.USER_NOT_FOUND &&
              location.pathname !== `/auth/forgot-password`)
          ) {
            clearToken();
            history.replace('/auth/login', { locationAfterLogIn: location });
          }
        }
      }),
    [clearToken, history, location]
  );

  return useMemo(() => responseErrorHandlerLink.concat(authLink).concat(httpLink), [
    responseErrorHandlerLink,
  ]);
};
